import useTranslation from 'next-translate/useTranslation';
import useApplicationData from 'src/hooks/useApplicationData';
import useKeyboardInteractions from 'src/hooks/useKeyboardInteractions';
import useSubtitle from 'src/hooks/useSubtitle';
import { NAVIGATION_KEYS } from 'src/interfaces/enums';
import { IconSize } from 'src/interfaces/Icon';
import SettingOption from 'src/themes/cosmos/components/SettingOption';
import { ChevronRightIcon, SubtitleIcon } from 'src/themes/cosmos/icons';
import SubtitleStylesIcon from 'src/themes/cosmos/icons/SubtitleStylesIcon';
import { detectIOS } from 'src/utils/browserUtils';
import useMenuRoute from 'src/themes/shared/containers/MenuRouteContainer/hooks/useMenuRoute';
import Toggle from 'src/themes/cosmos/components/Toggle';
import SettingOptionLabel from 'src/themes/cosmos/components/SettingOptionLabel';
import { MENU_ROUTES } from '../../routes';
import styles from './styles.module.scss';

const HomeSubtitleControlContainer = () => {
  const { t } = useTranslation('common');
  const { push } = useMenuRoute();
  const { subtitleLabel, toggleSubtitle, subtitleEnabled } = useSubtitle();
  const { flags } = useApplicationData();
  const { registerItem } = useKeyboardInteractions();

  const ariaLabelSubtitleEnabled = subtitleEnabled
    ? t('aria_labels.controls.subtitles.disable')
    : t('aria_labels.controls.subtitles.enable');

  return (
    <>
      <SettingOption
        {...registerItem({ index: 0 })}
        data-testid='toggle-subtitle-content'
        onClick={toggleSubtitle}
        aria-label={ariaLabelSubtitleEnabled}
        rightIcon={
          <span className={styles.toggleContainer}>
            <Toggle checked={subtitleEnabled} data-testid='subtitle-toggle' />
          </span>
        }
      >
        <SettingOptionLabel label={t('subtitles.active_subtitle')} />
      </SettingOption>
      <SettingOption
        {...registerItem({
          index: 1,
          keyActions: {
            [NAVIGATION_KEYS.ARROW_RIGHT]: () => push(MENU_ROUTES.SUBTITLES),
          },
        })}
        role='menuitem'
        aria-haspopup
        data-testid='settings-option-go-to-subtitles'
        rightIcon={<ChevronRightIcon />}
        onClick={() => push(MENU_ROUTES.SUBTITLES)}
      >
        <SettingOptionLabel
          label={
            <>
              <SubtitleIcon size={IconSize.small} className={styles.subtitleIcon} />
              {t('subtitles.language')}
            </>
          }
          value={subtitleLabel}
        />
      </SettingOption>
      {flags.ENABLE_PLAYER_COSMOS_CUSTOM_SUBTITLE_STYLES && !detectIOS() && (
        <SettingOption
          {...registerItem({
            index: 2,
            keyActions: {
              [NAVIGATION_KEYS.ARROW_RIGHT]: () => push(MENU_ROUTES.STYLES),
            },
          })}
          disabled={!subtitleEnabled}
          aria-haspopup
          data-testid='settings-option-go-to-styles'
          rightIcon={<ChevronRightIcon />}
          onClick={() => push(MENU_ROUTES.STYLES)}
        >
          <SettingOptionLabel
            label={
              <>
                <SubtitleStylesIcon className={styles.subtitleIcon} />
                {t('subtitles.styles.label')}
              </>
            }
          />
        </SettingOption>
      )}
    </>
  );
};

export default HomeSubtitleControlContainer;
